angular.module('unica_campaign_template.campaign_template_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// CAMPAIGN
		.state('app.campaign_template', {
			url: '/campaign-template',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/campaign-template/templates/campaign-template.html',
					controller: 'CampaignTemplateBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// CAMPAIGN TEMPLATE LIST
			.state('app.campaign_template.list', {
				url: '/list/:event_id',
				views: {
					'campaignTemplateContent': {
						templateUrl: './modules/campaign-template/templates/list.html',
						controller: 'CampaignTemplateListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Lista Template Campagne',
					parent: function($scope) {
						return 'app.campaign.list({ event_id:' + $scope.event_id + ' })';
					}
				}
			})

			// CAMPAIGN TEMPLATE CREATE
			.state('app.campaign_template.create', {
				url: '/create/:event_id',
				views: {
					'campaignTemplateContent': {
						templateUrl: './modules/campaign-template/templates/create.html',
						controller: 'CampaignTemplateCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Template Campagna',
					parent: 'app.campaign_template.list'
				}
			})

			// CAMPAIGN TEMPLATE EDIT
			.state('app.campaign_template.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'campaignTemplateContent': {
						templateUrl: './modules/campaign-template/templates/edit.html',
						controller: 'CampaignTemplateEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Template Campagna',
					parent: 'app.campaign_template.list'
				}
			});


});
